import { useEffect, useRef } from 'react';

export default function useDebounce<T extends unknown[]>(
	callback: (...args: T) => void,
	ms: number,
) {
	const debounceRef = useRef<ReturnType<typeof setTimeout>>();

	useEffect(() => () => clearTimeout(debounceRef.current), []);

	return (...args: T) => {
		clearTimeout(debounceRef.current);
		debounceRef.current = setTimeout(() => callback(...args), ms);
	};
}
